import type { FaireProductEntity } from "../../entity_types/product";

export const p_akkrz65agq: FaireProductEntity = {
  token: "p_akkrz65agq",
  type: "product",
  name: "Round Shaped Color Line Enamel Hoop Earrings",
  brandToken: "b_drzk7thxry",
  brandName: "Designature New York",
  imageUrl:
    "https://cdn.faire.com/fastly/fdbca4d0afebeecba47632be5e921c8859157b9c721afbd97f15e48f133ce704.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bd1cd87f7c16c05c6ffa334ccb0f7a053302f38aeed2f1b02dc773ccea221b2f.jpeg",
    "https://cdn.faire.com/fastly/d2c9d04006c1ab91052a9e981ec786cf0b43fe525fc1a1f609270606fc4d8558.jpeg",
    "https://cdn.faire.com/fastly/0d0b4ed1e58936cf3560389af3631c5c2853db411be21ca3523688880ae77d7b.jpeg",
    "https://cdn.faire.com/fastly/d6643cc014cb437ca8589afc5143fd1f5b7b306183424743191066d25ad61e25.jpeg",
    "https://cdn.faire.com/fastly/ab22d6b6997e94480592f5e8045bda3f08fa9184b30627caf82668bbe5cedfa5.jpeg",
  ],
  priceDollars: 5.5,
  description:
    "These 1.25 inch round shaped enamel hoop earrings are a stylish addition to any outfit. The sleek design and durable material make them perfect for everyday wear. With a professional tone, these earrings are expertly crafted and provide a timeless and elegant look. \n\n*Design in New York City\n*We only sell it in 3 pack units. (3pack, 6pack, 9pack...)\n\nLENGTH : 1 INCH\nCOLOR : BLUE / JET BLACK / LAVENDER / MULTI / PINK\n\nHOOP EARRINGS\nCOLOR",
  tags: [],
  msrpDollars: 16.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T20:37:47.547Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
